import React, { Component } from "react";
import "./css/BuyTokensMessage.css";

class BuyTokensMessage extends Component {

    render() {
        return (
            <>
                <div className="title title-thin title-xl-2">
                    <h1>Buy Tokens</h1>
                </div>
                <div className="lead-s2 lead-light">
                    Buy CHARRY Tokens today with both TRX and INR at our discounted prices!
                </div>
            </>
        );
    }
}

export default BuyTokensMessage;